<template>
  <div class="o-card">
    <loading v-if="getBatteryLoadingById || !batteryIsLoaded"></loading>
    <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
    <div v-else>
      <battery-features :form="batteryItem"></battery-features>
    </div>
  </div>
</template>

<script>
import Loading from "../Base/Loading/Loading.vue";
import batteryMixin from "@/mixins/batteryMixin";
import BatteryFeatures from "../Batteries/BatteryForm/BatteryFeatures.vue";
import authorize from "../Batteries/authorize";
export default {
  components: { Loading, BatteryFeatures },
  mixins: [authorize, batteryMixin],
  data() {
    return {
      batteryId: null,
    };
  },
  created() {
    this.batteryId = Number(this.$route.params.id);
    // devamını mixin yapıyor.
  },
};
</script>

<style></style>
